import { createContext, useContext, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(() => {
    const token = localStorage.getItem("ows_token");
    return token ? { token } : null;
  });

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("ows_token", data.token);
    setAdmin({ token: data.token, email: data.email, name: data.name });
    return data;
  };

  const logout = () => {
    localStorage.removeItem("ows_token");
    setAdmin(null);
  };

  const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem("ows_token")}` });

  return <AuthCtx.Provider value={{ admin, login, logout, authHeader }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
